import React, { useState, useEffect } from "react";

// Custom components
import toastManager from "../../../helpers/toastManager";
import AuthenticationCard from "../../../components/Authentication/AuthenticationCard";
import EmailSentPrompt from "../../../components/Authentication/EmailSentPrompt";
import { RegularField } from "../../../components/InputFields/InputFields";

// API imports
import useAxios from "../../../hooks/useAxios";
import jsonFormat from "../../../apis/jsonFormat";

// Detect enter press
import { useEnterKeyPress } from "../../../hooks/useEnterKeyPress";

const EmailResetRequestScreen = () => {
  const [email, setEmail] = useState("");
  const [emailWarning, setEmailWarning] = useState(false);

  const [emailSent, setEmailSent] = useState(false);

  // API Start
  const { response, error, axiosFetch } = useAxios();

  // Validate that email is in form of example@domain.com
  const validateEmail = (email) => {
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  };

  const handleSubmit = () => {
    // Verify that an email has been entered, and that it is in email format.
    if (email && validateEmail(email)) {
      axiosFetch({
        axiosInstance: jsonFormat(),
        method: "POST",
        url: "user/password_reset",
        sendSignal: false,
        requestConfig: {
          email: email,
          authentication_origin: "clinical_dashboard",
        },
      });
    } else {
      toastManager(
        "warning",
        "Can't send request.",
        "Please enter a valid email."
      );
    }
    !email || !validateEmail(email)
      ? setEmailWarning(true)
      : setEmailWarning(false);
  };

  // RESPONSE Detection
  useEffect(() => {
    // 1: Custom action code handling.
    // Account successfully created.
    if (response) {
      if (response?.action_code === "email_sent") {
        setEmailSent(true);

        toastManager(
          "success",
          "Reset request sent!",
          "Follow the link in your email to get your username and complete the password reset."
        );
      }
    }
  }, [response]);

  // ERROR Detection
  useEffect(() => {
    if (error) {
      // 1: Custom action_code handling.
      // Email is not in database.
      if (error?.email?.action_code === "unknown_email") {
        toastManager(
          "warning",
          "Email not recognized!",
          "The email you entered is not associated with any accounts on Dermi."
        );
      }
    }
  }, [error]);
  // API End

  // Detect enter press
  useEnterKeyPress(handleSubmit);

  return (
    <AuthenticationCard
      AuthenticationPromptTitle={"Request Password Reset"}
      AuthenticationPromptText={
        "Forgot your username or password? We'll email you a reset link."
      }
      AuthenticationButtonPrompt={"Request Reset"}
      AuthenticationButtonFunction={handleSubmit}
      redirectOption={"register"}
    >
      {emailSent && (
        <EmailSentPrompt
          title={"Email Sent!"}
          prompt={
            "Follow the link in your email to complete password reset. You can close this tab."
          }
        />
      )}

      <RegularField
        fieldLabel="Email"
        placeholderText="Enter your email"
        setFunction={setEmail}
        value={email}
        fieldWarning={emailWarning}
      />
    </AuthenticationCard>
  );
};

export default EmailResetRequestScreen;
